import { hex_sha1 } from './sha1';
import config from './config'
import urls from './urls';

let api = {}
api.map = {
  "proxy_pinter": location.protocol + "//pinter.funshion.com",
  "proxy_puser": location.protocol + "//puser.funshion.com",
  "proxy_pvip": location.protocol + "//pvip.funshion.com",
  "proxy_pst": location.protocol + "//pst.funshion.com",
  "proxy_ps": location.protocol + "//ps.funshion.com"
}
api.params = {
  timeout: 30, //接口超时时长(单位:秒)
  dataType: 'json',
  contentType: 'application/x-www-form-urlencoded',
  method: 'get',
  url: '',
  key: '',
  params: {}
}
api.defaultDomain = "//pm.funshion.com"
api.concatParams = function (source) {
  let p = Object.assign({}, api.params);
  p = Object.assign(p, source);
  if (source.params) {
    for (var i in source.params) {
      p.params[i] = source.params[i]
    }
  }
  delete p.params.url;
  if (!p.key) {
    p.key = hex_sha1(p.url + new Date().valueOf());
  }
  return p;
}
api.resolveUrl = function (url, relative) {
  if (!/https?/.exec(url)) {
    if (/^\/\//.exec(url)) {
      url = location.protocol + url;
    } else {
      url = location.protocol + (relative ? '' : api.defaultDomain) + url;
    }
  }
  return url;
}

/**
 * ajax接口调用
 * @param {string} url 接口地址
 * @param {object} option 请求选项，结构如:{url,params,key, relative}
   //relatve标记为相对url，对于开发环境代理测试，解决远端接口跨域问题
 * @param {function} cb 回调函数
 * @return Promise

 * example:

    api.poseidon("//pm.funshion.com/v5/media/profile", {
      id:320095
  }).then(res=>{
      console.log('res');
  }).catch(e=>{})

  api.poseidon("//pm.funshion.com/v5/media/profile", {
      id:320095
  }, function(data){
    console.log(data)
  })
 */
api.get = function (url, option, cb) {
  let opt = api.concatParams(option);
  let relative = false;
  if (opt.relative) {
    relative = option.relative
  }
  opt.url = api.resolveUrl(url, relative);
  if (!config.development) {
    //替换 proxy_xxx的测试代理
    let reg = /http:\/(proxy_\w+)/i;
    let matches = reg.exec(opt.url)
    if (matches) {
      let key = matches[1];
      if (api.map[key]) {
        opt.url = opt.url.replace(reg, api.map[key])
      }
    }
  }
  let race = Promise.race([
    new Promise((resolve, reject) => {
      //console.log('get:', urls.addURLParams( opt.url, opt.params ))
      $.ajax({
        type: opt.method,
        url: opt.url,
        data: opt.params,
        dataType: opt.dataType,
        success: function (data) {
          // console.log( urls.addURLParams( opt.url, opt.params ));
          data.__key = opt.key;
          resolve(data);
          cb && cb(data);
        },
        fail: function () {
          reject({ code: 400 })
        }
      });
    }),
    new Promise((resolve, reject) => {
      this._timeoutId = setTimeout(() => reject({ code: 503, message: "timeout" }), opt.timeout * 1000)
    })
  ]);
  return race;
}

// 波塞冬公共参数入口
api.poseidonCommonParams = (function () {
  return {
    ves: config.ves,
    cl: config.cl,   // 客户端类型
    uc: config.uc,  // 用户权限代码
    fudid: config.fudid, // 客户端标识
    ve: config.ve || '', // 客户端版本
    cp: 'fr4k0se', // 客户端渠道 通用参数
    ctime: Math.floor(new Date().valueOf() / 1000)  // 请求的时间戳
  }
})();

//printer.funshion.com
api.poseidonCommonParamsNew = (function () {
  return {
    fudid: config.fudid,
    timestamp: Math.floor(new Date().valueOf() / 1000),
    app_code: config.cl
  }
})();

api.getPuParams = function(params){
  params = params || {};
  return {
    fudid: config.fudid,
    timestamp: Math.floor(new Date().valueOf() / 1000),
    app_code: config.cl
  }
}

api.poseidonSessionParams = (function () {
  return {
    user_id: config.uid,
    token: config.token
  }
})
/**
 * 波塞冬接口调用
 * @param {string} url 接口地址
 * @param {object} option 请求选项，结构如:{url,params,key}
 * @param {function} cb 回调函数
 * @return Promise
 * example:
 * api.poseidon("po.funshion.com/", {a:1})
 */
api.poseidon = function (url, option, cb) {
  option.params = Object.assign(option.params, api.poseidonCommonParams);
  return api.get(url, option, cb);
}

export default api;



// WEBPACK FOOTER //
// ./src/assets/js/api.js